import { PaymentError } from '../core/payment-error';
import { PaymentConfig } from '../types';

const isAbsoluteUrl = (value: string): boolean => {
    try {
        return Boolean(new URL(value));
    } catch {
        return false;
    }
};

export const validateConfig = (config: PaymentConfig): void => {
    if (!config.userSessionToken) {
        throw new PaymentError(
            'User session token is required',
            'VALIDATION_ERROR'
        );
    }
    if (!config.container) {
        throw new PaymentError('Container is required', 'VALIDATION_ERROR');
    }
    if (
        !config.environment ||
        !['test', 'sandbox', 'live'].includes(config.environment)
    ) {
        throw new PaymentError(
            'Environment must be "test", "sandbox", or "live"',
            'VALIDATION_ERROR'
        );
    }
    if (
        config.region !== undefined &&
        !['eu-central-1', 'us-east-2', 'ap-southeast-4'].includes(config.region)
    ) {
        throw new PaymentError(
            'Region must be "eu-central-1", "us-east-2", or "ap-southeast-4"',
            'VALIDATION_ERROR'
        );
    }
    if (!config.countryCode) {
        throw new PaymentError('Country code is required', 'VALIDATION_ERROR');
    }
    if (!config.locale) {
        throw new PaymentError('Locale is required', 'VALIDATION_ERROR');
    }
    if (config.returnUrl !== undefined && !isAbsoluteUrl(config.returnUrl)) {
        throw new PaymentError(
            'Return URL must be an absolute URL including a scheme (e.g. "https://app.example.com/return" or "myapp://payment-return")',
            'VALIDATION_ERROR'
        );
    }
};
